export default class Page
{
    constructor(app) {
        this.app = app;
    }

    show(params) {

    }
}